/**
 * Announces header predictive search results to assistive technology and
 * keeps combobox ARIA state in sync when results load or clear.
 */
(function () {
  const PLACEHOLDER_COUNT = "__COUNT__";

  function initHeaderSearch(headerSearch) {
    const input = headerSearch.querySelector("#predictive-search-form input[name='q']");
    const resultsSlot = headerSearch.querySelector("predictive-search [slot='results']");
    const statusEl = headerSearch.querySelector("[data-predictive-search-status]");

    if (!input || !resultsSlot || !statusEl) {
      return;
    }

    const strings = {
      loading: statusEl.dataset.loading || "Loading search results.",
      results: statusEl.dataset.results || "",
      noResults: statusEl.dataset.noResults || "No results found.",
      cleared: statusEl.dataset.cleared || "",
    };

    const announce = (message) => {
      if (!message) {
        statusEl.textContent = "";
        return;
      }
      statusEl.textContent = "";
      requestAnimationFrame(() => {
        statusEl.textContent = message;
      });
    };

    const setExpanded = (expanded) => {
      input.setAttribute("aria-expanded", expanded ? "true" : "false");
    };

    const summarizeResults = () => {
      if (!input.value.trim()) {
        setExpanded(false);
        if (strings.cleared) {
          announce(strings.cleared);
        } else {
          announce("");
        }
        return;
      }

      const noResults = resultsSlot.querySelector(".predictive-search__no-results");
      if (noResults) {
        setExpanded(true);
        announce(strings.noResults);
        return;
      }

      const suggestionCount = resultsSlot.querySelectorAll(".predictive-search__suggestions a").length;
      const productCount = resultsSlot.querySelectorAll(
        ".predictive-search__products .product-card, .predictive-search__products .horizontal-product-card"
      ).length;
      const linkCount = resultsSlot.querySelectorAll(".predictive-search__results a").length;
      const total = Math.max(suggestionCount + productCount, linkCount);

      if (resultsSlot.children.length === 0) {
        setExpanded(false);
        announce("");
        return;
      }

      setExpanded(true);

      if (total > 0 && strings.results.includes(PLACEHOLDER_COUNT)) {
        announce(strings.results.replace(PLACEHOLDER_COUNT, String(total)));
      } else if (total > 0) {
        announce(strings.results || `${total} results available below.`);
      } else {
        announce(strings.results.replace(PLACEHOLDER_COUNT, "").trim() || "Search results are available below.");
      }
    };

    const observer = new MutationObserver(summarizeResults);
    observer.observe(resultsSlot, { childList: true, subtree: true });

    input.addEventListener("input", () => {
      if (!input.value.trim()) {
        setExpanded(false);
        announce("");
      }
    });

    let searchLoading = false;

    document.documentElement.addEventListener("theme:loading:start", () => {
      if (!headerSearch.hasAttribute("open") || !input.value.trim()) {
        return;
      }
      searchLoading = true;
      input.setAttribute("aria-busy", "true");
      announce(strings.loading);
    });

    document.documentElement.addEventListener("theme:loading:end", () => {
      if (!searchLoading) {
        return;
      }
      searchLoading = false;
      input.removeAttribute("aria-busy");
      summarizeResults();
    });
  }

  function boot() {
    document.querySelectorAll("header-search").forEach(initHeaderSearch);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
